<div class="comment-container">
    <div class="comment-avatar">
        <mat-icon>account_circle</mat-icon>
    </div>
    <div class="comment-details">
        <div [uiScrollIntoView]="editing"
             class="comment-header">
            <span class="comment-author">
                {{original?.userName}}
            </span>
            <ui-dateformat #creationTimeFormat
                           [matTooltip]="creationTimeFormat?.dataset['title']"
                           [date]="original?.creationTime"
                           contentType="relative"
                           class="comment-date">
            </ui-dateformat>
        </div>
        <p *ngIf="!editing"
           class="comment-body">{{original?.text}}</p>
        <div *ngIf="editing">
            <form [formGroup]="form"
                  (submit)="save()">
                <mat-form-field>
                    <textarea [uiAutofocus]
                              matInput
                              formControlName="text"
                              class="comment-edit"
                              required></textarea>
                    <mat-hint *ngIf="!form.get('text')!.pristine && form.get('text')!.hasError('maxlength')"
                              [translateParams]="{
                                max: form.get('text')!.getError('maxlength').requiredLength
                              }"
                              translate
                              class="errorMessage">
                        transaction_details_comment_new_comment_warning
                    </mat-hint>
                </mat-form-field>
                <div class="button-container">
                    <button (click)="cancel()"
                            mat-button
                            type="submit"
                            class="button-flat-attn">
                        {{ 'comments_cancel' | translate }}
                    </button>
                    <button [disabled]="saving ||
                                        form.invalid ||
                                        form.pristine"
                            [spinnerButtonLoading]="saving"
                            ui-spinner-button
                            mat-button
                            type="submit"
                            class="button-flat-attn">
                        {{ 'comments_save_comment' | translate }}
                    </button>
                </div>
            </form>
        </div>
    </div>
    <div class="comment-actions">
        <button [uiAuthorizeDisable]="editPermission"
                [matMenuTriggerFor]="menu"
                [disableIf]="disable"
                [matTooltip]="'global_more_actions_tooltip' | translate"
                mat-icon-button
                type="button">
            <mat-icon svgIcon="uipath:More"></mat-icon>
        </button>
        <mat-menu #menu="matMenu"
                  xPosition="before">
            <button (click)="edit()"
                    mat-menu-item
                    type="button">
                <mat-icon svgIcon="uipath:Edit"></mat-icon>
                <span translate>comments_edit</span>
            </button>
            <button (click)="delete()"
                    mat-menu-item
                    color="warn"
                    type="button">
                <mat-icon svgIcon="uipath:Delete"></mat-icon>
                <span translate>comments_remove</span>
            </button>
        </mat-menu>
    </div>
</div>
